// Copyright (C) 2021 Bystronic Laser AG

export enum SortOrder {
  Ascending = 'asc',
  Descending = 'desc',
}
